const INITIAL_STATE = {};


export default function balance(state = INITIAL_STATE, { type, payload }) {
    
    // console.log(' payload.key',  payload.key);

  switch (type) {
    case 'data-load_FULFILLED': {
      if (payload && payload.key === 'balance') {
        return {
          ...payload.response.data,
        }
      }

      return state;
    }

    case 'app/reset': {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}

